<template>
  <div v-if="data">
    <h2 class="text-black mb-3 pt-4">
      Watching Brief
      <small class="text-muted">(optional)</small>
    </h2>

    <form-control
      class="mb-3"
      v-model="data.link"
      :errors="error ? error.errors.watching_brief.link : []"
      :no-margin="true"
      title="Watching Brief Video Link"
      placeholder="Enter video link"
    />

    <div class="form-group">
      <label>Watching Brief Video Image</label>
      <img
        v-if="data.image"
        :src="data.image.url"
        :alt="data.image.name"
        style="max-width: 520px;"
        class="d-block mb-2"
      />

      <FileUpload
        :action="`${url}upload/image`"
        :accept="['image/png', 'image/jpeg']"
        :headers="headers"
        @input="briefVideoPictureUploaded"
        :value="this.data.image ? [this.data.image] : []"
        class="el-upload-100"
      />
      <!-- <img
          v-if="data.image"
          :src="data.image.url"
          :alt="data.image.name"
          class="w-auto h-100"
        >

        <div v-else>
          <icon
            icon="add-image"
            class="m-0"
          />
          <div class="el-upload__text">
            Drop your file here or <em>Browse</em>
          </div>
        </div>
      </el-upload>-->
    </div>

    <div class="form-group border-bottom pb-5 mb-3">
      <label>Watching Brief Video Source/Notes</label>

      <HtmlEditor
        v-model="data.source"
        :token="`Bearer ${$login.getToken()}`"
        :image-upload-url="imageUploadUrl"
        :file-upload-url="fileUploadUrl"
      />
    </div>
  </div>
</template>

<script>
import { HtmlEditor, FileUpload } from '@frontend/components'
export default {
  name: 'WatchingBriefSection',
  components: {
    HtmlEditor,
    FileUpload
  },

  props: {
    value: {
      type: Object,
      required: true
    }
  },

  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$login.getToken()
      }
    }
  },
  data: () => ({
    data: null,
    error: null,
    url: process.env.VUE_APP_API_ENDPOINT,
    imageUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/image',
    fileUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/file'
  }),

  mounted() {
    this.data = this.value
  },

  watch: {
    data() {
      this.$emit('input', this.data)
    },

    value() {
      this.data = this.value
    }
  },

  methods: {
    briefVideoPictureUploaded(fileList) {
      const img = !fileList[0]
        ? null
        : {
            name: fileList[0].name,
            url: fileList[0].url
          }

      this.data.image = img
    }
  }
}
</script>
